import React from "react";
import { useTranslation } from "react-i18next";
import Password from "./Password";
import Account from "./Account";
import SessionsPage from "../../../pages/Dashboard/SessionsPage";

function SectionBlock({ title, children }) {
  return (
    <div className="tw-flex tw-flex-col tw-gap-4">
      <div className="tw-flex tw-items-center tw-gap-3">
        <h3 className="tw-text-xs tw-font-semibold tw-uppercase tw-tracking-widest tw-text-white/30 tw-m-0">
          {title}
        </h3>
        <div className="tw-flex-1 tw-h-px tw-bg-white/10" />
      </div>
      {children}
    </div>
  );
}

export default function Security() {
  const { t } = useTranslation();

  return (
    <div className="tw-flex tw-flex-col tw-gap-8">
      <SectionBlock title={t("Change Password")}>
        <Password />
      </SectionBlock>

      <SectionBlock title={t("Active Sessions")}>
        <SessionsPage embedded />
      </SectionBlock>

      <SectionBlock title={t("Danger Zone")}>
        <Account />
      </SectionBlock>
    </div>
  );
}
